import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { Stack as o } from "@mui/material";
import { useSideNav as s } from "./useSideNav2.mjs";
import { StackHeader as a, Logo as r } from "./styles120.mjs";
const l = () => {
  const { isExpanded: i } = s();
  return /* @__PURE__ */ e(
    a,
    {
      direction: "row",
      alignItems: "center",
      justifyContent: "flex-start",
      children: /* @__PURE__ */ t(o, { direction: "row", children: [
        /* @__PURE__ */ e(r, { size: "small", $isVisible: i }),
        " ",
        /* @__PURE__ */ e(r, { size: "small", compact: !0, $isVisible: !i })
      ] })
    }
  );
};
export {
  l as SideNavHeader
};
//# sourceMappingURL=index313.mjs.map
